import { render } from "./icon-service.vue?vue&type=template&id=648a4b14&ts=true"
import script from "./icon-service.vue?vue&type=script&lang=ts"
export * from "./icon-service.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__